// extracted by mini-css-extract-plugin
export default {"stageBase":"stages_stageBase__xO0Md","comfortable":"stages_comfortable__tHOom","fullWidth":"stages_fullWidth__0ZVAm"};